export default {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  GRAPHQL_API_ENDPOINT: process.env.REACT_APP_GRAPHQL_API_ENDPOINT,
  ASSET_URL: process.env.REACT_APP_ASSET_URL,
  GHN_API: process.env.REACT_APP_GHN_API || 'https://dev-online-gateway.ghn.vn/shiip/public-api'
}